import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    modalHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    modalOverlay: {
        justifyContent: "flex-end",
        flexDirection: "row",
        flex: 1
    },
    participantButton: {
        flexDirection: "row",
        alignItems: "center"
    },
    participantItem: {
        flexDirection: "row",
        alignItems: "center"
    },
    avatarPlaceholder: {
        height: 40,
        width: 40
    },
    modalContent: {
        height: "100%"
    },
    participantInfo: {
        flex: 1
    },
    avatar: {
        height: 40,
        width: 40
    },
    container: {
        flex: 1
    }
});

export default stylesheet;
